import {RecordsActionTypes, SaJooRecord} from "./types";
import {action} from "typesafe-actions";


export const changeSaJooRecords = (saJooRecords: SaJooRecord[]) => action(RecordsActionTypes.CHANGE_SAJOO_RECORDS, {saJooRecords})
export const fetchSaJooRecord = (code: string) => action(RecordsActionTypes.FETCH_SAJOO_RECORD, {code})